import { useState } from "react";

import Image from "next/image";

import NewUserForm from "../newUserForm";
import OtpConfirm from "../otpConfirm";
import SignIn from "../signin";

function AuthWrapper() {
  const [currentStep, setCurrentStep] = useState("SIGN_IN");
  const [loginData, setLoginData] = useState(null);

  const handleRedirectToOtp = (data) => {
    setLoginData(data);
    setCurrentStep("OTP");
  };

  const authStepComponent = {
    SIGN_IN: (
      <SignIn
        previousNumber={loginData?.phone}
        redirectToOtp={(data) => handleRedirectToOtp(data)}
      />
    ),
    OTP: (
      <OtpConfirm
        loginData={loginData}
        updateLoginData={(data) => setLoginData(data)}
        redirectToRegister={() => setCurrentStep("NEW_USER")}
        onChangePhoneNumber={() => setCurrentStep("SIGN_IN")}
      />
    ),
    NEW_USER: <NewUserForm prevData={loginData} />,
  };

  return (
    <div className="h-full w-full gap-3 rounded-[0.75rem] border border-grayDisplay-100 px-[1.25rem] lg:grid lg:min-h-[27.5rem] lg:grid-cols-2 lg:px-0 lg:pl-[1.5rem] xl:min-h-[35.5rem] xl:pl-[2.5rem]">
      <div className="flex h-full items-center pb-4 pt-3">
        {authStepComponent[currentStep]}
      </div>
      <div className="hidden justify-end lg:flex">
        <div className="relative h-full w-full">
          <Image
            fill
            priority
            sizes="33vw"
            quality={60}
            alt="Electronics Experiment"
            className="rounded-r-[0.75rem]"
            src="https://apn089-robodoc-prod.sgp1.cdn.digitaloceanspaces.com/static/auth-image.png"
          />
        </div>
      </div>
    </div>
  );
}

export default AuthWrapper;
